/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ServiceType } from 'app/shared/model/enumerations/service-type.model';
import { SubscriptionType } from 'app/shared/model/enumerations/subscription-type.model';
import { Period } from 'app/shared/model/enumerations/period.model';

export interface ISubscriptionPlan {
  id?: string;
  serviceType?: keyof typeof ServiceType;
  subscriptionType?: keyof typeof SubscriptionType;
  period?: keyof typeof Period;
  amount?: number;
  active?: boolean;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  cursor?: number;
}

export const defaultValue: Readonly<ISubscriptionPlan> = {
  active: false,
};
